import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class PhysicalZone extends BasicEntity {
children: {[key: string]: PhysicalZone};
code: string;
description: TranslatedEmb;
direction: string;
hasRedimChild: boolean | null;
height: number | null;
hideable: boolean | null;
isFinal: boolean | null;
label: TranslatedEmb;
level: number | null;
minHeight: number | null;
minWidth: number | null;
order: number | null;
parentCode: string;
percentHeight: number | null;
percentWidth: number | null;
resizable: boolean | null;
templateCode: string;
width: number | null;
}

